import React from 'react';
import { string, shape } from 'prop-types';
import PressEnquiries from './index';

const PressEnquiriesBlock = ({
    title,
    generalEmail,
    contact,
    contactLinkText,
    contactLinkUrl
}) => {
    if (!title || !generalEmail) return null;

    return (
        <PressEnquiries
            title={title}
            generalEmail={generalEmail}
            contactName={contact?.name}
            contactTitle={contact?.jobTitle}
            contactEmail={contact?.email}
            contactImage={contact?.photo?.gatsbyImageData}
            contactLinkText={contactLinkText}
            contactLinkUrl={contactLinkUrl}
        />
    );
};

PressEnquiriesBlock.propTypes = {
    title: string.isRequired,
    generalEmail: string.isRequired,
    contact: shape({
        name: string,
        jobTitle: string,
        email: string,
        photo: shape({})
    }),
    contactLinkText: string,
    contactLinkUrl: string
};

PressEnquiriesBlock.defaultProps = {
    contact: null,
    contactLinkText: null,
    contactLinkUrl: null
};

export default PressEnquiriesBlock;
